import Mock from 'mockjs'
import cache from '../../common/cache'

let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 客户列表
Mock.mock(/sales_receptions\/customers/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'customer_infos': [
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196', 'ES7826196', 'ES7826196', 'ES7826196', 'ES7826196', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      }

    ],
    'total_count': 50
  },
  'message': 'ok'
})
